












import { Component, Vue, Prop } from 'vue-property-decorator';
import IStar from './types';

@Component
export default class Star extends Vue implements IStar {
  @Prop({ type: Boolean, default: false })
  filled: boolean;

  get fillColor(): string {
    return this.filled ? '#8181ca' : '#fff';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/review/components/stars/components/star/Star.vue